import React, { FC } from "react";
import styled from "styled-components";
import { vwMobile, vwDesktop, rem } from "../../helpers/styles";
import { BREAKPOINTS } from "../../helpers/theme";
import SectionLines from "../SectionLines";

export type IntroLineProps = {
  id?: string;
  headline: string;
  as?: "h1" | "h2" | "h3" | "h4";
  className?: string;
};

const IntroLine: FC<IntroLineProps> = ({
  id,
  headline,
  as = "h2",
  className,
}: IntroLineProps) => {
  const stripHTML = (html?: string): string => {
    if (!html) return "";

    return html
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/gi, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  return (
    <Wrapper id={id} className={className}>
      <IconWrapper aria-hidden="true">
        <LeafIcon />
      </IconWrapper>
      <Headline as={as}>{stripHTML(headline)}</Headline>
    </Wrapper>
  );
};

export default IntroLine;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  background-color: #f6f1e7;

  padding-top: ${vwMobile(80)};
  padding-bottom: ${vwMobile(80)};
  padding-left: ${vwMobile(64)};
  padding-right: ${vwMobile(64)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-top: ${vwDesktop(120)};
    padding-bottom: ${vwDesktop(120)};
    padding-left: ${vwDesktop(265)};
    padding-right: ${vwDesktop(265)};
  }
  ${SectionLines("#012604")};

  scroll-margin-top: ${rem(64)};
`;

const IconWrapper = styled.div`
  margin-bottom: ${vwMobile(13)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-bottom: ${vwDesktop(20)};
  }
`;

const Headline = styled.h2`
  color: #012604;
  font-family: "GT Alpina";
  font-style: normal;
  font-weight: 300;
  text-align: center;
  font-size: ${rem(30)};
  line-height: 95%;
  letter-spacing: ${vwMobile(-1.5)};
  max-width: ${vwMobile(340)};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    font-size: ${rem(52)};
    line-height: 104%;
    letter-spacing: ${vwDesktop(-2.6)};
  }
`;

const LeafIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="27"
    viewBox="0 0 22 27"
    fill="none"
  >
    <path
      d="M20.6944 10.7081C20.6899 12.4011 20.0384 14.0968 18.7422 15.3931C17.4461 16.6891 15.7507 17.3399 14.058 17.3446C14.0627 15.6519 14.7135 13.9565 16.0095 12.6604C17.3057 11.3642 19.0015 10.7126 20.6944 10.7081Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5625"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.88758 10.7081C1.89208 12.4011 2.54364 14.0968 3.83988 15.3931C5.13597 16.6891 6.83129 17.3399 8.52402 17.3446C8.51936 15.6519 7.86851 13.9565 6.57253 12.6604C5.27631 11.3642 3.58051 10.7126 1.88758 10.7081Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5625"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.3841 1.16992C13.1541 2.96837 14.2487 5.45532 14.2487 8.20203C14.2486 10.9483 13.1537 13.4341 11.3841 15.2324C9.61458 13.4341 8.51962 10.9483 8.51953 8.20203C8.51953 5.45537 9.6142 2.96836 11.3841 1.16992Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5625"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.125 25.1283C11.125 22.4841 11.125 21.0016 11.125 18.3574"
      stroke="currentColor"
      strokeWidth="1.5625"
      strokeLinecap="round"
    />
    <path
      d="M15.4961 21.3428L11.1428 25.696L6.7896 21.3428"
      stroke="currentColor"
      strokeWidth="1.5625"
    />
  </svg>
);
